export const handleCustomFormat = ({
  value,
  mask
}: {
  value: string
  mask: string
}) => {
  const length = value.length

  if (length <= 16)
    return {
      format: `#### #### #### #####`,
      mask: ''
    }

  return { format: `#### #### #### #######`, mask }
}
